import { apiSlice } from "../../../features/api/apiSlice";

function pick(res: any) {
  return res?.data?.data ?? res?.data ?? res;
}

// ✅ ALWAYS returns an array
function pickArray(res: any) {
  const d = pick(res);
  if (Array.isArray(d)) return d;
  if (Array.isArray(d?.data)) return d.data;
  if (Array.isArray(res?.data)) return res.data;

  return [];
}

export const receiptApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getReceipt: builder.query<any, string>({
      query: (ref) => `/receipts/${ref}`,
      providesTags: ["Receipt"],
    }),

    downloadReceipt: builder.query<Blob, string>({
      query: (ref) => ({
        url: `/receipts/${ref}/download`,
        responseHandler: (response: any) => response.blob(),
      }),
    }),

    getMyPayments: builder.query<any[], void>({
      query: () => `/my-payments`,
      providesTags: ["Payments"],
    }),
    startInvoiceItemPayment: builder.mutation<any, string>({
      query: (itemId) => ({
        url: `/invoice-items/${itemId}/pay`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetReceiptQuery,
  useLazyDownloadReceiptQuery,
  useGetMyPaymentsQuery,
  useStartInvoiceItemPaymentMutation,
} = receiptApi;
